import { Link } from 'gatsby';
import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import LogoSVG from './svgs/logo';
var TopNav = function TopNav(_ref) {
    var brandName = _ref.brandName;
    var links = [{
            name: 'Brand Heart',
            path: '/brand-heart'
        }, {
            name: 'Brand Messaging',
            path: '/brand-messaging'
        }, {
            name: 'Visual Identity',
            path: '/visual-identity'
        }];
    return /*#__PURE__*/ React.createElement(Navbar, {
        bg: "light",
        expand: "md",
        variant: "light",
        fixed: "top",
        className: "border-bottom"
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Navbar.Brand, null, /*#__PURE__*/ React.createElement(Link, {
        to: "/",
        className: "text-dark font-weight-bolder"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, brandName), /*#__PURE__*/ React.createElement(LogoSVG, {
        height: "20px",
        className: "svg-fill-dark"
    }))), /*#__PURE__*/ React.createElement(Navbar.Toggle, {
        "aria-controls": "responsive-navbar-nav"
    }), /*#__PURE__*/ React.createElement(Navbar.Collapse, {
        id: "responsive-navbar-nav"
    }, /*#__PURE__*/ React.createElement(Nav, {
        className: "ml-auto pt-4 pt-md-0",
        as: "ul"
    }, links.map(function (_ref2, index) {
        var name = _ref2.name, path = _ref2.path;
        var itemKey = "navbar-nav-" + index;
        return /*#__PURE__*/ React.createElement(Nav.Item, {
            as: "li",
            key: itemKey
        }, /*#__PURE__*/ React.createElement(Link, {
            to: path,
            className: "nav-link",
            activeClassName: "active disabled text-decoration-underline"
        }, name));
    })))));
};
export default TopNav;
